import React from 'react'

import { ReactComponent as DiconnectedSvg } from 'assets/svg/connection-lost/disconnected.svg'
import { Loading } from 'components/shared'
import './ConnectionLost.scss'
import { useTranslation } from 'react-i18next'

export function ConnectionLost() {
    const { t } = useTranslation()
    return (
        <div className="connection-lost-page">
            <h2 className="connection-lost-page__title">{t('int_connection_lost')}</h2>
            <div className="d-flex flex-column align-items-center">
                <DiconnectedSvg />
                <Loading />
            </div>
            <div>
                <p className="connection-lost-page__text">{t('int_connnection_lost_desc')}</p>
            </div>
        </div>
    )
}
